"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecialtyAbbreviation = void 0;
const SPECIALTY_ABBREVIATIONS = {
    cardiac_cath_lab: 'Cath Lab',
    case_management: 'CM',
    emergency_department: 'ED',
    endoscopy: 'GI',
    home_health: 'HH',
    house_supervisor: 'House Sup',
    icu: 'ICU',
    iv_infusion: 'Infusion',
    labor_and_delivery: 'L&D',
    long_term_care: 'LTC',
    medical_surgical: 'Med-Surg',
    medical_surgical_telemetry: 'Med-Surg Tele',
    nicu: 'NICU',
    operating_room: 'OR',
    pacu: 'PACU',
    pediatric: 'Peds ED',
    pediatric_acute: 'Peds Acute',
    picu: 'PICU',
    progressive_care: 'PCU',
    mental_health: 'Psych',
};
const getSpecialtyAbbreviation = (specialty) => SPECIALTY_ABBREVIATIONS[specialty.code] ?? specialty.name;
exports.getSpecialtyAbbreviation = getSpecialtyAbbreviation;
//# sourceMappingURL=specialty-abbreviation.js.map